import { ResponsiveBar } from '@nivo/bar';
import React from 'react';

const MyResponsiveBar = ({ data }) => (
  <ResponsiveBar
    data={data}
    keys={['total_gas_filled']}
    indexBy="gas_pump_id"
    margin={{ top: 20, right: 20, bottom: 50, left: 60 }}
    padding={0.3}
    valueScale={{ type: 'linear' }}
    indexScale={{ type: 'band', round: true }}
    // colors={{ scheme: 'greens' }}
    colors="#07efb8"
    theme={{
      fontSize: 10,
      textColor: '#000000',
      labels: {
        text: {
          fontWeight: 'bolder'
        }
      },
      axis: {
        legend: {
          text: {
            fontSize: 20,
            fontWeight: 'bold',
            fill: '#000000'
          }
        }
      },
      legends: {
        title: {
          text: {
            fontSize: 18,
            fontWeight: 'bold',
            fill: '#000000'
          }
        },
        text: {
          fontSize: 18,
          fontWeight: 'bold',
          fill: '#000000'
        },
        ticks: {
          line: {},
          text: {
            fontSize: 12,
            fontWeight: 'bold',
            fill: '#000000'
          }
        }
      }
    }}
    defs={[
      {
        id: 'dots',
        type: 'patternDots',
        background: 'inherit',
        color: '#38bcb2',
        size: 4,
        padding: 1,
        stagger: true
      },
      {
        id: 'lines',
        type: 'patternLines',
        background: 'inherit',
        color: '#eed312',
        rotation: -45,
        lineWidth: 6,
        spacing: 10
      }
    ]}
    borderColor={{
      from: 'color',
      modifiers: [['darker', 1.6]]
    }}
    axisTop={null}
    axisRight={null}
    axisBottom={{
      tickSize: 5,
      tickPadding: 5,
      tickRotation: 0,
      legend: 'Pump ID',
      legendPosition: 'middle',
      legendOffset: 37
    }}
    axisLeft={{
      tickSize: 5,
      tickPadding: 5,
      tickRotation: 0,
      legend: `Total Sales (KG)`,
      legendPosition: 'middle',
      legendOffset: -52
    }}
    labelSkipWidth={12}
    labelSkipHeight={12}
    labelTextColor={{
      from: 'color',
      modifiers: [['darker', 1.6]]
    }}
    role="application"
    ariaLabel="PumP Sales"
    barAriaLabel={(e) => `${e.id}: ${e.formattedValue} in month: ${e.indexValue}`}
  />
);

export default MyResponsiveBar;
